import invariant from 'invariant';
import apiRequest from 'lib/apiRequest';
import EventTracking from 'lib/EventTracking';
import CurrentUser from 'auth/CurrentUser';
import Cookies from 'lib/Cookies';

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'Runtime' implicitly has an 'any' type.
function remindApiAuthorizer(Runtime, socketId: string, callback: Function) {
  if (!CurrentUser.isSignedIn()) {
    callback(true, 'user not signed in');
    return;
  }

  if (!Cookies.isEnabled()) {
    callback(true, 'user does not have cookies enabled');
    return;
  }
  // to match https://github.com/pusher/pusher-js/blob/master/src/runtimes/isomorphic/auth/xhr_auth.ts
  apiRequest('/pusher/auth', 'POST', {
    socket_id: socketId,
    // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
    channel_name: this.channel.name,
  })
    .then((data) => callback(false, data))
    .catch((err) => {
      console.debug('remindApiAuthorizer pusher auth failure', err);
      callback(true, err.message);
    });
}

// @ts-expect-error ts-migrate(7034) FIXME: Variable 'singleton' implicitly has type 'any' in ... Remove this comment to see the full error message
let singleton = null;

function ensureSingleton(key: string) {
  // @ts-expect-error ts-migrate(7005) FIXME: Variable 'singleton' implicitly has an 'any' type.
  if (singleton) {
    return;
  }

  // Postpone module load until there's a connection to be opened so that this
  // PusherConnection module can load in Node.
  const Pusher = require('pusher-js');

  const supportedAuthorizers = Pusher.Runtime.getAuthorizers();
  Pusher.Runtime.getAuthorizers = function () {
    supportedAuthorizers.remindApi = remindApiAuthorizer;
    return supportedAuthorizers;
  };

  singleton = new Pusher(key, {
    authTransport: 'remindApi',
    encrypted: true,
  });

  // https://pusher.com/docs/client_api_guide/client_connect#available-states
  // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'previous' implicitly has an 'any'... Remove this comment to see the full error message
  singleton.connection.bind('state_change', function ({ previous, current }) {
    EventTracking.track(`pusher.state_change.${previous}.to.${current}`);
  });

  window.addEventListener('beforeunload', () => {
    closeConnection();
  });
}

/**
 * @param  {[String]} key required to open a connection
 * @return {[Pusher]} connection singleton
 */
export function openConnection(key: string) {
  invariant(key, 'Missing Pusher key.');

  ensureSingleton(key);
  // @ts-expect-error ts-migrate(7005) FIXME: Variable 'singleton' implicitly has an 'any' type.
  invariant(singleton, 'Connection not available to open');

  // @ts-expect-error ts-migrate(7005) FIXME: Variable 'singleton' implicitly has an 'any' type.
  singleton.connect(); // idempotent

  // @ts-expect-error ts-migrate(7005) FIXME: Variable 'singleton' implicitly has an 'any' type.
  return singleton;
}

export function closeConnection() {
  // @ts-expect-error ts-migrate(7005) FIXME: Variable 'singleton' implicitly has an 'any' type.
  if (singleton) {
    // @ts-expect-error ts-migrate(7005) FIXME: Variable 'singleton' implicitly has an 'any' type.
    singleton.disconnect();
    // leave the singleton object to reconnect if needed
  }
}

export function resetConnection() {
  // @ts-expect-error ts-migrate(7005) FIXME: Variable 'singleton' implicitly has an 'any' type.
  invariant(singleton, 'Connection not available to reset');
  // @ts-expect-error ts-migrate(7005) FIXME: Variable 'singleton' implicitly has an 'any' type.
  singleton.disconnect();
  // @ts-expect-error ts-migrate(7005) FIXME: Variable 'singleton' implicitly has an 'any' type.
  singleton.connect();
}
